define("shared/components/shared/profile-categorization/modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _computed, _service, _utils, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{fn this.promptToCloseModal false}}
    {{did-insert this.bindKeyHandler}}
    {{will-destroy this.unbindKeyHandler}}
    as |modal|
  >
  
    <modal.card @portrait={{true}} class="u--p__b__0">
  
      <modal.card-body class="u--p__0">
        <div class="tSC--wrapper u--p__lr__md u--m__tb__lg">
          {{#if @isProfileCategorized}}
            <Shared::ProfileCategorization::RewardsSteps::Report
              @businessModel={{this.businessModel}}
              @category={{this.category}}
              @exitCategorization={{this.promptToCloseModal}}
              @forceHideReports={{@forceHideReports}}
              @resetSelection={{this.resetSelection}}
              @sectionName={{@sectionName}}
              @setReportState={{this.setReportState}}
              @socialProfile={{@socialProfile}}
            />
          {{else}}
            {{#if this.isSavingProfile}}
              <Shared::ProfileCategorization::CategorizeSteps::ProgressBar
                @progressValue={{0}}
                @socialProfile={{@socialProfile}}
              />
  
              <Shared::ProfileCategorization::Loading />
            {{else if this.isSettingIndustry}}
              <Shared::ProfileCategorization::CategorizeSteps
                @sectionName={{@sectionName}}
                @socialProfile={{@socialProfile}}
                @submitCategorizationInfo={{this.submitCategorizationInfo}}
              />
            {{else}}
              <Shared::ProfileCategorization::RewardsSteps::Report
                @businessModel={{this.businessModel}}
                @category={{this.category}}
                @exitCategorization={{this.promptToCloseModal}}
                @forceHideReports={{@forceHideReports}}
                @resetSelection={{this.resetSelection}}
                @sectionName={{@sectionName}}
                @setReportState={{this.setReportState}}
                @socialProfile={{@socialProfile}}
              />
            {{/if}}
          {{/if}}
        </div>
  
      </modal.card-body>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "nvGLntMw",
    "block": "[[[8,[39,0],[[4,[38,2],[[30,0,[\"bindKeyHandler\"]]],null],[4,[38,3],[[30,0,[\"unbindKeyHandler\"]]],null]],[[\"@close\"],[[28,[37,1],[[30,0,[\"promptToCloseModal\"]],false],null]]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"u--p__b__0\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tSC--wrapper u--p__lr__md u--m__tb__lg\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[8,[39,5],null,[[\"@businessModel\",\"@category\",\"@exitCategorization\",\"@forceHideReports\",\"@resetSelection\",\"@sectionName\",\"@setReportState\",\"@socialProfile\"],[[30,0,[\"businessModel\"]],[30,0,[\"category\"]],[30,0,[\"promptToCloseModal\"]],[30,3],[30,0,[\"resetSelection\"]],[30,4],[30,0,[\"setReportState\"]],[30,5]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSavingProfile\"]],[[[1,\"            \"],[8,[39,6],null,[[\"@progressValue\",\"@socialProfile\"],[0,[30,5]]],null],[1,\"\\n\\n            \"],[8,[39,7],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSettingIndustry\"]],[[[1,\"            \"],[8,[39,8],null,[[\"@sectionName\",\"@socialProfile\",\"@submitCategorizationInfo\"],[[30,4],[30,5],[30,0,[\"submitCategorizationInfo\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,5],null,[[\"@businessModel\",\"@category\",\"@exitCategorization\",\"@forceHideReports\",\"@resetSelection\",\"@sectionName\",\"@setReportState\",\"@socialProfile\"],[[30,0,[\"businessModel\"]],[30,0,[\"category\"]],[30,0,[\"promptToCloseModal\"]],[30,3],[30,0,[\"resetSelection\"]],[30,4],[30,0,[\"setReportState\"]],[30,5]]],null],[1,\"\\n          \"]],[]]]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"@isProfileCategorized\",\"@forceHideReports\",\"@sectionName\",\"@socialProfile\"],false,[\"shared/modal\",\"fn\",\"did-insert\",\"will-destroy\",\"if\",\"shared/profile-categorization/rewards-steps/report\",\"shared/profile-categorization/categorize-steps/progress-bar\",\"shared/profile-categorization/loading\",\"shared/profile-categorization/categorize-steps\"]]",
    "moduleName": "shared/components/shared/profile-categorization/modal.hbs",
    "isStrictMode": false
  });

  const ESC_KEY = 27;
  let ModalComponent = (_dec = (0, _computed.reads)('args.socialProfile.isProfessional'), _dec2 = (0, _computed.reads)('analytics.instagramAccountTypeName'), (_class = class ModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "segment", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "alerts", _descriptor5, this);

      _initializerDefineProperty(this, "isSettingIndustry", _descriptor6, this);

      _initializerDefineProperty(this, "isSavingProfile", _descriptor7, this);

      _initializerDefineProperty(this, "isReportEmpty", _descriptor8, this);

      _initializerDefineProperty(this, "isProfessional", _descriptor9, this);

      _initializerDefineProperty(this, "instagramAccountTypeName", _descriptor10, this);

      if (this.args.socialProfile.industry && this.args.isRecategorizingFromChangeIndustryTab) {
        this._trackRestartedCategorization('settings', this.args.socialProfile.industry, this.args.socialProfile.businessModel);

        this._clearSocialProfile();
      } else {
        this._trackStartedCategorization();
      }

      this.boundKeyHandler = this._keyHandler.bind(this);
      this.isSettingIndustry = !this.args.isProfileCategorized;
    }

    bindKeyHandler() {
      document.addEventListener('keyup', this.boundKeyHandler);
    }

    unbindKeyHandler() {
      document.removeEventListener('keyup', this.boundKeyHandler);
    }

    setReportState(isReportEmpty) {
      this.isReportEmpty = isReportEmpty;
    }

    resetSelection() {
      this._clearSocialProfile();

      this.args.socialProfile.save();
    }

    promptToCloseModal(isSkip) {
      this._promptToCloseModal(isSkip);
    }

    submitCategorizationInfo(selectedCategory, selectedIndustry, selectedBusinessModel, otherIndustry, otherBusinessModel, keywordIndustry, keywordBusinessModel, businessType) {
      this.args.socialProfile.setProperties({
        category: selectedCategory ? selectedCategory.value : null,
        industry: selectedIndustry ? selectedIndustry.value : null,
        businessModel: selectedBusinessModel ? selectedBusinessModel.value : null,
        otherIndustry: otherIndustry || null,
        otherBusinessModel: otherBusinessModel || null,
        keywordIndustry: keywordIndustry ? keywordIndustry.toLowerCase() : null,
        keywordBusinessModel: keywordBusinessModel ? keywordBusinessModel.toLowerCase() : null,
        businessType: businessType ? businessType.value : null
      });
      this.isSavingProfile = true;
      this.args.socialProfile.save().then(() => {
        this.isSavingProfile = false;
        this.isSettingIndustry = false;
      });
    }

    _trackFinishedCategorization() {
      const {
        category,
        industry,
        businessModel,
        otherIndustry,
        otherBusinessModel,
        keywordIndustry,
        keywordBusinessModel,
        businessType
      } = this.args.socialProfile || {};

      this._trackEnteredIndustry(category, industry, otherIndustry, keywordIndustry);

      this._trackEnteredBusinessModel(businessType, businessModel, otherBusinessModel, keywordBusinessModel);
    }

    _trackEnteredIndustry(category, industry, otherIndustry, keyword) {
      const segmentEventName = 'entered-industry-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;
      this.segment.trackWithError(segmentEventName, {
        area: this.args.sectionName,
        user,
        profile: id,
        category,
        other_industry: otherIndustry,
        industry,
        other_autocomplete: (0, _utils.isPresent)(keyword),
        keyword,
        social_profile_nickname: nickname
      }, () => `Error Tracking ${segmentEventName} from location ${this.args.sectionName}`);
    }

    _trackEnteredBusinessModel(businessType, businessModel, otherBusinessModel, keyword) {
      const segmentEventName = 'entered-bus-model-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;
      this.segment.trackWithError(segmentEventName, {
        area: this.args.sectionName,
        user,
        profile: id,
        bus_type: businessType,
        bus_model: businessModel,
        other_bus_model: otherBusinessModel,
        other_autocomplete: (0, _utils.isPresent)(keyword),
        keyword,
        social_profile_nickname: nickname
      }, () => `Error Tracking ${segmentEventName} from location ${this.args.sectionName}`);
    }

    _promptToCloseModal(isSkip) {
      const shouldShowAreYouSureModal = !isSkip && (this.isSettingIndustry || !this.isReportEmpty);

      if (shouldShowAreYouSureModal) {
        const prefix = this.isSettingIndustry ? 'close_profile_setup' : 'close_industry_comparison';
        this.dialogManager.confirm(this.intl.t(`profile_categorization.reports.${this.args.sectionName}.${prefix}.header`), {
          description: this.intl.t(`profile_categorization.reports.${this.args.sectionName}.${prefix}.subcopy`),
          confirmButton: this.intl.t(`profile_categorization.reports.${this.args.sectionName}.${prefix}.confirm`),
          cancelButton: this.intl.t(`profile_categorization.reports.${this.args.sectionName}.${prefix}.cancel`)
        }).then(() => this._closeModal());
      } else {
        this._closeModal();
      }
    }

    _closeModal() {
      if (this.args.socialProfile.industry) {
        this._trackFinishedCategorization();

        this.alerts.success(this.intl.t('alerts.profile_categorization.general.success'));
      }

      this.args.toggleCategorizationModal();
    }
    /**
     * Handles keyup events, only watching for events
     * on the Escape key, which will call the `_promptToCloseModal` action
     * which will close the modal.
     *
     * @method _keyHandler
     * @protected
     */


    _keyHandler(event) {
      const key = event.key || event.keyCode;

      if (key === 'Escape' || key === ESC_KEY) {
        const isSkip = false;

        this._promptToCloseModal(isSkip);
      }
    }

    _trackStartedCategorization() {
      const segmentEventName = 'started-self-cat';
      this.segment.trackWithError(segmentEventName, {
        area: this.args.sectionName,
        profile: this.args.socialProfile.id,
        is_professional: this.isProfessional,
        social_profile_nickname: this.args.socialProfile.nickname
      }, () => `Error Tracking ${segmentEventName} from location ${this.args.sectionName}`);
    }

    _trackRestartedCategorization(page, previous_industry, previous_business_model) {
      const eventName = 'redid-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;
      this.segment.trackWithError(eventName, {
        area: 'settings/hashtag_analytics',
        user,
        profile: id,
        is_business: this.isBusiness,
        page,
        previous_industry,
        previous_business_model,
        social_profile_nickname: nickname
      }, () => `Error Tracking ${eventName} from location ${this.args.sectionName}`);
    }

    _clearSocialProfile() {
      this.isSettingIndustry = true;
      this.isReportEmpty = false;
      this.isSavingProfile = false;
      this.args.socialProfile.setProperties({
        category: null,
        industry: null,
        businessModel: null,
        otherIndustry: null,
        otherBusinessModel: null
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSettingIndustry", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isSavingProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isReportEmpty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isProfessional", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "instagramAccountTypeName", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "bindKeyHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "bindKeyHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unbindKeyHandler", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "unbindKeyHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setReportState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setReportState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptToCloseModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "promptToCloseModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitCategorizationInfo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "submitCategorizationInfo"), _class.prototype)), _class));
  _exports.default = ModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ModalComponent);
});